import { render } from "./address_assign.vue?vue&type=template&id=9043fad8&scoped=true"
import script from "./address_assign.vue?vue&type=script&lang=js"
export * from "./address_assign.vue?vue&type=script&lang=js"

import "./address_assign.vue?vue&type=style&index=0&id=9043fad8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9043fad8"]])

export default __exports__